var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWarningLine(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.039 3.039 1.4 4.678v4.644l1.639 1.639L4.678 12.6h4.644l1.639-1.639L12.6 9.322V4.678l-1.639-1.639L9.322 1.4H4.678L3.039 3.039m7.21.712 1.348 1.347v3.804l-1.348 1.347-1.347 1.348H5.098l-1.347-1.348-1.348-1.347V5.098l1.348-1.347 1.347-1.348h3.804l1.347 1.348m-3.418.847a.343.343 0 0 0-.134.138c-.046.089-.047.135-.047 1.566 0 1.457.001 1.474.049 1.561A.39.39 0 0 0 7 8.05a.39.39 0 0 0 .301-.187c.048-.087.049-.104.049-1.563 0-1.459-.001-1.476-.049-1.563a.345.345 0 0 0-.47-.139m0 4.55a.38.38 0 0 0-.181.304c0 .168.181.348.35.348.17 0 .35-.18.35-.35 0-.172-.181-.351-.353-.349a.46.46 0 0 0-.166.047",
    fillRule: "evenodd"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWarningLine);
export default __webpack_public_path__ + "static/media/warning-line.0bceddf9b6858f7d07383492843f3402.svg";
export { ForwardRef as ReactComponent };